(function(){
  var trigger = document.querySelector('.amm-trigger');
  var menu = document.getElementById('amm');
  var scrim = document.getElementById('amm-scrim');
  if (!trigger || !menu) return;

  /* Living under <body> keeps the panel clear of the header's own
     stacking context and overflow rules. */
  document.body.appendChild(menu);
  document.body.appendChild(scrim);

  var rail = menu.querySelector('.amm-rail');
  var pill = menu.querySelector('.amm-pill');
  var items = menu.querySelectorAll('.amm-ri');
  var panels = menu.querySelectorAll('.amm-p');
  var openT, closeT, hideT, railT, isOpen = false, warmed = false;

  function headerBottom(){
    var h = trigger.closest('header, .header, height-observer, .shopify-section') || trigger;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }

  /* Height = room left under the header, minus a margin, capped so big
     monitors don't get a sheet taller than its content wants. */
  function fit(){
    var top = headerBottom();
    var room = window.innerHeight - top - 18;
    menu.style.setProperty('--amm-top', top + 'px');
    scrim.style.setProperty('--amm-top', top + 'px');
    menu.style.setProperty('--amm-h', Math.max(380, Math.min(room, 780)) + 'px');
  }

  function placePill(el, instant){
    if (!el) return;
    if (instant) rail.classList.add('no-anim');
    pill.style.setProperty('--y', el.offsetTop + 'px');
    pill.style.setProperty('--h', el.offsetHeight + 'px');
    if (instant) { pill.offsetHeight; rail.classList.remove('no-anim'); }
  }

  function open(){
    clearTimeout(closeT); clearTimeout(hideT);
    if (isOpen) return;
    isOpen = true;
    fit();
    menu.hidden = false; scrim.hidden = false;
    placePill(menu.querySelector('.amm-ri.is-on'), true);
    requestAnimationFrame(function(){ menu.classList.add('is-open'); scrim.classList.add('is-open'); });
    if (!warmed) { warmed = true; (window.requestIdleCallback || setTimeout)(function(){
      menu.querySelectorAll('img[loading="lazy"]').forEach(function(im){ im.loading = 'eager'; });
      menu.querySelectorAll('.amm-cell[data-img]').forEach(function(c){ if (c.dataset.img) { var i = new Image(); i.src = c.dataset.img; } });
    }); }
    trigger.setAttribute('aria-expanded', 'true');
  }

  function close(){
    clearTimeout(openT);
    if (!isOpen) return;
    isOpen = false;
    menu.classList.remove('is-open'); scrim.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    hideT = setTimeout(function(){ if (!isOpen) { menu.hidden = true; scrim.hidden = true; } }, 560);
  }

  function activate(item){
    if (!item || item.classList.contains('is-on')) return;
    var id = item.dataset.p;
    for (var i = 0; i < items.length; i++) items[i].classList.toggle('is-on', items[i] === item);
    for (var k = 0; k < panels.length; k++){
      var on = panels[k].dataset.p === id;
      panels[k].hidden = !on;
      panels[k].classList.toggle('is-in', on);
    }
    placePill(item, false);
  }

  /* Hover intent: a short delay to open, a longer grace to close, so the
     panel neither flickers on a passing cursor nor vanishes on the way in. */
  trigger.addEventListener('mouseenter', function(){ clearTimeout(closeT); openT = setTimeout(open, 90); });
  trigger.addEventListener('mouseleave', function(){ clearTimeout(openT); closeT = setTimeout(close, 220); });
  menu.addEventListener('mouseenter', function(){ clearTimeout(closeT); });
  menu.addEventListener('mouseleave', function(){ closeT = setTimeout(close, 220); });
  scrim.addEventListener('mouseenter', function(){ closeT = setTimeout(close, 120); });
  scrim.addEventListener('click', close);

  trigger.addEventListener('click', function(e){ if (!isOpen) { e.preventDefault(); open(); } });
  trigger.addEventListener('keydown', function(e){
    if (e.key === 'ArrowDown') { e.preventDefault(); open(); var f = menu.querySelector('.amm-ri.is-on'); if (f) f.focus(); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && isOpen) { close(); trigger.focus(); } });
  window.addEventListener('resize', function(){ if (isOpen) { fit(); placePill(menu.querySelector('.amm-ri.is-on'), true); } });

  /* Rail: a 70ms settle stops diagonal cursor paths from strobing panels. */
  for (var i = 0; i < items.length; i++){
    (function(it){
      it.addEventListener('mouseenter', function(){ clearTimeout(railT); railT = setTimeout(function(){ activate(it); }, 70); });
      it.addEventListener('focus', function(){ activate(it); });
    })(items[i]);
  }
  rail.addEventListener('mouseleave', function(){ clearTimeout(railT); });

  /* Card crossfade: the hovered cell's collection photo fades in over the
     current one; the layer that just lost becomes the next back layer. */
  /* every card's blurred backdrop starts as its current photo */
  menu.querySelectorAll('.amm-card').forEach(function(card){
    var w = card.querySelector('.amm-cimg'), im = card.querySelector('.amm-cimg img.is-top, .amm-cimg img.is-a');
    if (w && im) { var set = function(){ w.style.setProperty('--amm-cbg', 'url("' + im.src + '")'); }; if (im.src) set(); im.addEventListener('load', set); }
  });

  menu.querySelectorAll('.amm-p').forEach(function(p){
    var card = p.querySelector('.amm-card');
    if (!card) return;
    var a = card.querySelector('.is-a'), b = card.querySelector('.is-b');
    if (!a || !b) return; /* feature panels have a fixed photo */
    var front = a, back = b, title = card.querySelector('.amm-ch'), want = '';
    var wrap = card.querySelector('.amm-cimg');
    a.classList.add('is-top');
    /* start on the first cell's own photo (menu thumbs override collection images) */
    var c1 = p.querySelector('.amm-cell[data-img]:not([data-img=""])');
    if (c1 && a.src.indexOf(c1.dataset.img) < 0) a.src = c1.dataset.img;
    p.querySelectorAll('.amm-cell').forEach(function(cell){
      cell.addEventListener('mouseenter', function(){
        var src = cell.dataset.img; if (!src || front.src.indexOf(src) > -1) return;
        want = src;
        card.href = cell.href;
        title.textContent = cell.dataset.t + (title.dataset.suffix || '');
        back.onload = function(){
          if (back.src.indexOf(want) < 0) return;
          back.classList.add('is-top'); front.classList.remove('is-top');
          wrap.style.setProperty('--amm-cbg', 'url("' + back.src + '")');
          var t = front; front = back; back = t;
        };
        back.src = src;
      });
    });
  });
})();

/* ── mobile drawer: takes over the theme's hamburger below 1000px ── */
(function(){
  var dr = document.getElementById('amd');
  if (!dr) return;
  document.body.appendChild(dr);
  var hideT, lastBtn;
  function open(btn){
    clearTimeout(hideT); lastBtn = btn;
    dr.hidden = false; document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function(){ dr.classList.add('is-open'); });
    var x = dr.querySelector('.amd-x'); if (x) setTimeout(function(){ x.focus(); }, 300);
  }
  function close(){
    dr.classList.remove('is-open'); document.documentElement.style.overflow = '';
    hideT = setTimeout(function(){ dr.hidden = true; }, 600);
    if (lastBtn) lastBtn.focus();
  }
  /* Capture phase so the theme's own sidebar never sees the click. */
  window.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('button[aria-controls="sidebar-menu"]');
    if (!b || window.innerWidth >= 1000) return;
    e.preventDefault(); e.stopImmediatePropagation(); open(b);
  }, true);
  dr.querySelector('.amd-x').addEventListener('click', close);
  dr.addEventListener('click', function(e){ if (e.target === dr) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !dr.hidden) close(); });
  var its = dr.querySelectorAll('.amd-it');
  its.forEach(function(it){
    var row = it.querySelector('.amd-row');
    row.addEventListener('click', function(){
      var willOpen = !it.classList.contains('is-open');
      its.forEach(function(o){ o.classList.remove('is-open'); o.querySelector('.amd-row').setAttribute('aria-expanded', 'false'); });
      if (willOpen){
        it.classList.add('is-open'); row.setAttribute('aria-expanded', 'true');
        setTimeout(function(){ row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 260);
      }
    });
  });
})();
